import React from "react";
import "./notFound.scss";
import { Link } from "react-router-dom";

const NotFound = () => {
    return (
        <div className="center">
            <div className="mobile-error">
                <div className="mobile-number">404</div>
            </div>
            <div className="error">
                <div className="number">4</div>
                <div className="illustration">
                    <div className="circle"></div>
                    <div className="clip">
                        <div className="paper">
                            <div className="face">
                                <div className="eyes">
                                    <div className="eye eye-left"></div>
                                    <div className="eye eye-right"></div>
                                </div>
                                <div className="rosyCheeks rosyCheeks-left"></div>
                                <div className="rosyCheeks rosyCheeks-right"></div>
                                <div className="mouth"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="number">4</div>
            </div>

            <div className="text">Упс. Схоже такої сторінки не існує.</div>
            <Link className="button" to={"/dashboard"}>
                Повернутися Додому
            </Link>
        </div>
    );
};

export default NotFound;
